export default class LoginController {
  constructor(AuthService, $state, LoginService, $auth, Notification, ProfilePermissionsService, $window, 
    ContentService) {
    this.AuthService = AuthService;
    this.state = $state;
    this.service = LoginService;
    this.$auth = $auth;
    this.notify = Notification;
    this.permissionsService = ProfilePermissionsService;
    this.$window = $window;
    this.contentService = ContentService;
  }

  $onInit(){
    this.subscriptions = [];

    this.email = '';
    this.password = '';

    this.$window.localStorage.removeItem('jwtToken');
    this.$window.localStorage.removeItem('accToken');
    this.$window.localStorage.removeItem('currentProfile');
    this.$window.localStorage.removeItem('google_state');
    this.$window.localStorage.removeItem('profilesCount');
    this.$window.localStorage.removeItem('__paypal_storage__');
    this.$window.localStorage.removeItem('userlanguage');
    this.$window.localStorage.removeItem('accPayStatus');
    this.$window.localStorage.removeItem('trialPeriodEnding');
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  verifyProfile(response) {
    var invitations = response.data.invitations;
    var profiles = response.data.profiles;

    this.$window.localStorage.userLanguage = this.AuthService.getLanguage();

    if (invitations.length > 0){
      this.state.go('pendingInvitations', {invitations: invitations, profiles: profiles});
    } else if (profiles.length > 0) {
      this.permissionsService.setProfilesCount(profiles.length);
      this.state.go('profileSelection', {profiles: profiles, invitations: invitations});
    } else {
      this.state.go('accountRegistration', {invitations: invitations});
    }
  }

  login(){
    var that = this;
    this.subscriptions.push(
      this.AuthService.login(this.email, this.password).subscribe(
        (response) => this.verifyProfile(response),
        (err) => console.log(err)
      )
    );
  }

  authenticateOauth(provider) {
    if (provider !== 'google') return;

    this.$window.localStorage.removeItem('google_state');
    this.$auth.authenticate(provider, {fields: ['invitations', 'profiles']})
      .then(response => {
        this.verifyProfile(response);
      })
      .catch((error) => {
        if (error.message) {
          this.notify.error(error.message);
        } else if (error.data) {
          this.notify.error(error.data.message, error.status);
        } else {
          this.notify.error(error);
        }
      });
  }
}

 LoginController.$inject = [
   'AuthService', '$state', 'LoginService', '$auth', 'Notification', 'ProfilePermissionsService', 
   '$window', 'ContentService'
  ];


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js